import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { Modal } from '../../models/modal.model';

export enum AlertType {
  Information,
  Warning,
  Error,
  Success,
  Validation,
}

export interface IConfirmModalParameters {
  alertType: AlertType;
  title: string;
  message: string;
  canReject: boolean;
  confirmText?: string;
  rejectText?: string;
  confirmIcon?: string;
  confirmIconWeight?: string;
  hideFooter?: boolean;
  loading?: boolean;
  buttons: Array<{ text: string; result: any; isDisabled: boolean }>;
}

@Component({
  standalone: false,
  selector: 'nimbus-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmModalComponent implements OnInit, OnDestroy {
  public parameters$: ReplaySubject<IConfirmModalParameters> = new ReplaySubject(1);

  public TranslationKeys = TranslationKeys;

  public AlertType = AlertType;

  public constructor(private readonly modal: Modal<IConfirmModalParameters>) {}

  public ngOnInit(): void {
    this.parameters$.next(this.modal.parameters);
  }

  public ngOnDestroy(): void {
    this.parameters$.complete();
  }

  public close(result): void {
    this.modal.close(true, result);
  }
}
